var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.892,
    viewBox: "0 0 20 19.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M14.368,2.157a2,2,0,0,1,1.265,0l5,1.667A2,2,0,0,1,22,5.721V19.613a2,2,0,0,1-2.632,1.9L15,20.054,9.632,21.843a2,2,0,0,1-1.265,0l-5-1.667A2,2,0,0,1,2,18.279V4.387a2,2,0,0,1,2.632-1.9L9,3.946ZM15,4.054,9.632,5.843a2,2,0,0,1-1.265,0L4,4.387V18.279l5,1.667,5.368-1.789a2,2,0,0,1,1.265,0L20,19.613V5.721ZM13.293,8.293a1,1,0,0,1,1.414,0l.793.793.793-.793a1,1,0,0,1,1.414,1.414l-.793.793.793.793a1,1,0,1,1-1.414,1.414l-.793-.793-.793.793a1,1,0,0,1-1.414-1.414l.793-.793-.793-.793A1,1,0,0,1,13.293,8.293ZM6,16a1,1,0,1,0-1-1A1,1,0,0,0,6,16Zm3-4a1,1,0,1,1-1-1A1,1,0,0,1,9,12Zm2,0a1,1,0,1,0-1-1A1,1,0,0,0,11,12Z",
    transform: "translate(-2 -2.054)",
    fill: "#2d3040",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.76b7033cc2d99ca91e8912ab9022ed29.svg";
export { ForwardRef as ReactComponent };